/**
 * Scroll Reveal Handler - High Performance Version
 * 修正：移除動態 Tween 產生，改用 Pre-compiled 動畫與 fastScrollEnd 防護
 */
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

export function initScrollReveal() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const $allTargets = $('*').filter(function () {
    const attrs = this.attributes;
    for (let i = 0; i < attrs.length; i++) {
      if (attrs[i].name.startsWith('data-fade') || attrs[i].name.startsWith('data-mb')) return true;
    }
    return false;
  });

  const currentDevice = window.device || ($(window).width() > 1200 ? 'desktop' : 'mobile');
  const isMobile = currentDevice === 'mobile';

  const defaults = isMobile 
    ? { duration: 0.8, offset: 40, direction: 'up', stagger: 0.15, start: '85%' }
    : { duration: 0.8, offset: 40, direction: 'up', stagger: 0.15, start: '90%' };

  const $targets = $allTargets.filter(function () {
    const attrs = this.attributes;
    let hasGeneralFade = false;
    let hasDesktopDisable = false;
    for (let i = 0; i < attrs.length; i++) {
      const name = attrs[i].name;
      if (name.startsWith('data-fade') && !name.includes('mobile') && !name.includes('mb')) hasGeneralFade = true;
      if (name === 'data-fade-desktop' && attrs[i].value === 'false') hasDesktopDisable = true;
    }
    if (isMobile) return true;
    if (hasDesktopDisable) return false;
    return hasGeneralFade;
  });

  if ($targets.length === 0) return;

  // 1. 建立 Y 軸群組字典，用於計算 stagger
  const topGroups = new Map();
  
  $targets.each(function () {
    const el = this;
    // 使用 getBoundingClientRect 取代 jQuery offset，效能較佳
    const rectTop = Math.round(el.getBoundingClientRect().top + window.scrollY);
    
    // 容差值設定，將相近高度(10px內)的元素視為同一列
    const groupKey = Math.floor(rectTop / 10) * 10; 
    
    if (!topGroups.has(groupKey)) topGroups.set(groupKey, []);
    topGroups.get(groupKey).push(el);
  });

  // 2. 針對分組進行高階動畫綁定
  topGroups.forEach((elements) => {
    elements.forEach((el, index) => {
      const $el = $(el);
      
      const getParam = (baseName, mobileName, defaultVal) => {
        let val = $el.attr(baseName);
        if (isMobile && $el.attr(mobileName) !== undefined) val = $el.attr(mobileName);
        return val !== undefined ? val : defaultVal;
      };

      let direction = defaults.direction;
      const attrs = el.attributes;
      for (let i = 0; i < attrs.length; i++) {
        const name = attrs[i].name;
        if (name.includes('fade-up')) direction = 'up';
        else if (name.includes('fade-down')) direction = 'down';
        else if (name.includes('fade-left')) direction = 'left';
        else if (name.includes('fade-right')) direction = 'right';
        if (isMobile && (name.startsWith('data-mb-') || name.startsWith('data-fade-mobile-'))) {
            if (name.endsWith('up')) direction = 'up';
            if (name.endsWith('down')) direction = 'down';
            if (name.endsWith('left')) direction = 'left';
            if (name.endsWith('right')) direction = 'right';
        }
      }

      const duration = parseFloat(getParam('data-fade-duration', 'data-mb-duration', defaults.duration));
      const offsetValue = parseFloat(getParam('data-fade-offset', 'data-mb-offset', defaults.offset));
      const startPos = getParam('data-fade-start', 'data-mb-start', defaults.start);

      let startVars = { opacity: 0 };
      if (direction === 'up') startVars.y = offsetValue;
      else if (direction === 'down') startVars.y = -offsetValue;
      else if (direction === 'left') startVars.x = offsetValue;
      else if (direction === 'right') startVars.x = -offsetValue;

      // 重點：預先編譯動畫實體 (Pre-compiled Tween)
      const animationTween = gsap.fromTo(el, 
        startVars, 
        {
          opacity: 1, 
          x: 0, 
          y: 0,
          duration: duration,
          delay: index * defaults.stagger, // 保持原有的交錯邏輯
          ease: "power2.out",
          // 動畫結束時清除 inline styles，減少瀏覽器負擔
          clearProps: "transform,will-change" 
        }
      );

      // 將動畫實體直接綁定至 ScrollTrigger，取代 onEnter 建立
      ScrollTrigger.create({
        trigger: el,
        animation: animationTween,
        start: `top ${startPos}`,
        // play: 進入時播放 | none: 離開不動作 | none: 倒退進入不動作 | reverse: 倒退離開時反向播放
        toggleActions: "play none none reverse",
        fastScrollEnd: true, // 核心優化：快速滑動時直接跳至動畫終點
        preventOverlaps: true // 防止同元素的動畫重疊觸發
      });
    });
  });
}